module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bg-gray"
  }, [_c('div', {
    staticClass: "form-content"
  }, [_c('el-divider', [_vm._v(_vm._s(_vm.$T('人员信息')))]), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-plus"
    },
    on: {
      "click": function($event) {
        return _vm.openMemberDialog()
      }
    }
  }, [_vm._v(_vm._s(_vm.$T('添加成员')))])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.memberList,
      "border": "",
      "stripe": "",
      "size": "mini",
      "empty-text": _vm.$T('暂无数据')
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$T('职能'),
      "min-width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.funcTableLabel(scope.row.func)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "full_name",
      "label": _vm.$T('全名'),
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "birth_date",
      "label": _vm.$T('出生日期'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "fig_license",
      "label": _vm.$T('FIG执照'),
      "min-width": "120"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "passport_number",
      "label": _vm.$T('护照号码'),
      "min-width": "150"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('护照PDF'),
      "min-width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.pass_pdf.length > 0 ? _vm.$T('已上传') : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "pass_expiry_date",
      "label": _vm.$T('护照到期日'),
      "min-width": "140"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('国籍'),
      "min-width": "140"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(_vm.citizenshipTableLabel(scope.row.citizenship)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('照片'),
      "min-width": "90"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.photo.length > 0 ? _vm.$T('已上传') : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('保险'),
      "min-width": "110"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(scope.row.insurance.length > 0 ? _vm.$T('已上传') : '-'))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$T('操作'),
      "min-width": "140",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.openMemberDialog(scope.row, scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('编辑')))]), _vm._v(" "), _c('el-button', {
          staticStyle: {
            "color": "#f56c6c"
          },
          attrs: {
            "type": "text"
          },
          on: {
            "click": function($event) {
              return _vm.removeMember(scope.$index)
            }
          }
        }, [_vm._v(_vm._s(_vm.$T('删除')))])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "footer-button"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.saveLoading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$T('保存')))])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editingIndex > -1 ? _vm.$T('编辑成员') : _vm.$T('添加成员'),
      "visible": _vm.showMemberDialog,
      "width": "760px"
    },
    on: {
      "update:visible": function($event) {
        _vm.showMemberDialog = $event
      }
    }
  }, [_c('el-form', {
    ref: "memberFormRef",
    staticClass: "member-dialog-form",
    attrs: {
      "model": _vm.memberForm,
      "rules": _vm.memberRules,
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('职能'),
      "prop": "func"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$T('选择职能')
    },
    model: {
      value: (_vm.memberForm.func),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "func", $$v)
      },
      expression: "memberForm.func"
    }
  }, _vm._l((_vm.functionOptionsList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('全名'),
      "prop": "full_name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.memberForm.full_name),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "full_name", $$v)
      },
      expression: "memberForm.full_name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('出生日期'),
      "prop": "birth_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.memberForm.birth_date),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "birth_date", $$v)
      },
      expression: "memberForm.birth_date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('FIG执照'),
      "prop": "fig_license"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$T('没有证件号用0代替')
    },
    model: {
      value: (_vm.memberForm.fig_license),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "fig_license", $$v)
      },
      expression: "memberForm.fig_license"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('护照号码'),
      "prop": "passport_number"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.memberForm.passport_number),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "passport_number", $$v)
      },
      expression: "memberForm.passport_number"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('护照到期日'),
      "prop": "pass_expiry_date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "date",
      "value-format": "yyyy-MM-dd"
    },
    model: {
      value: (_vm.memberForm.pass_expiry_date),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "pass_expiry_date", $$v)
      },
      expression: "memberForm.pass_expiry_date"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12
    }
  }, [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$T('国籍'),
      "prop": "citizenship"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": _vm.$T('选择国籍'),
      "filterable": ""
    },
    model: {
      value: (_vm.memberForm.citizenship),
      callback: function($$v) {
        _vm.$set(_vm.memberForm, "citizenship", $$v)
      },
      expression: "memberForm.citizenship"
    }
  }, _vm._l((_vm.citizenshipOptionsList), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$T('护照PDF')
    }
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.memberForm.pass_pdf,
      "limit": 1,
      "accept": ".pdf"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$T('照片'),
      "prop": "photo"
    }
  }, [_c('PicUploader', {
    attrs: {
      "fileList": _vm.memberForm.photo,
      "limit": 1
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$T('保险')
    }
  }, [_c('FileUploader', {
    attrs: {
      "fileList": _vm.memberForm.insurance,
      "limit": 1,
      "accept": ".pdf,.jpg,.jpeg,.png"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showMemberDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$T('取消')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveMember
    }
  }, [_vm._v(_vm._s(_vm.$T('确定')))])], 1)], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-599ed03b","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/SaiApplyFormStep2.vue
// module id = 1461
// module chunks = 0